"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * `useWindow` hook will return window context and all customized helper functions.
 */
var useWindow = function useWindow() {
  var windowContext = typeof window === 'undefined' ? {} : window;
  var pushToDataLayer = function pushToDataLayer(_ref) {
    var event = _ref.event,
      data = _ref.data;
    var dataLayer = windowContext.dataLayer;
    dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push(_objectSpread({
      event: event
    }, data));
  };
  return {
    windowContext: windowContext,
    pushToDataLayer: pushToDataLayer
  };
};
var _default = useWindow;
exports.default = _default;